const GA = {
  initialize: () => console.log('initialize GA'),
  event: () => console.log('GA Event'),
  set: () => console.log('GA Set'),
  pageview: () => console.log('GA Pageview'),
};

export default GA;
